import { ReactNode } from 'react';
import { Button, type ButtonProps } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { COLORS } from 'theme/MainTheme';
import clsx from 'clsx';

type ColorsType = 'blue' | 'green' | 'light_red' | 'red' | 'violet' | 'white';

type StyleProps = {
  color: ColorsType;
}

const useStyles = makeStyles(() => ({
  button: {
    borderRadius: 15,
    minWidth: 0,
    padding: 15,

    '&:hover': {
      opacity: 0.7,
    },
  },
  color: ({color} : StyleProps) => ({
    backgroundColor: color,
    borderColor: color,
    color: COLORS.WHITE,

    '&:hover': {
      backgroundColor: color,
    },
  }),
  white: {
    backgroundColor: COLORS.WHITE,
    borderColor: COLORS.WHITE,
    color: COLORS.BLACK,

    '&:hover': {
      backgroundColor: COLORS.WHITE,
    },
  },
}), { name: 'FilledButton' });

export interface FilledButtonProps extends Omit<ButtonProps, 'color'>, StyleProps {
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
}

const FilledButton = ({ children, className, color, size = 'medium', ...props } : FilledButtonProps) : JSX.Element => {
  
  const classes = useStyles({color: COLORS[color.toUpperCase()]});

  return (
    <Button
      className={clsx(
        classes.button,
        color === 'white' ? classes.white : classes.color,
        className,
      )}
      data-testid={props['data-testid'] || 'filled-button'}
      size={size}
      variant="contained"
      {...props}
    >
      {children}
    </Button>
  );
};

export default FilledButton;